import type { Config, EditorField, PlayLike } from '../@types/editor'

export const getSelectedNumbers = (fields?: Maybe<EditorField[]>): Maybe<number>[] =>
  fields?.flatMap((field) =>
    field?.selected && field.selected.length >= 1 ? field.selected : null,
  ) ?? []

export const findFieldIndexByName = (play: PlayLike, name: string): number =>
  play.fields.findIndex((field) => field?.name === name)

export const findFieldByName = (play: PlayLike, name: string): EditorField | undefined =>
  play.fields[findFieldIndexByName(play, name)]

export const buildCardFields = <TExtra extends Record<string, unknown>>(
  config: Config,
  play: PlayLike,
  decorate: (field: EditorField | undefined, index: number) => TExtra,
): { name: string; numbers: (TExtra & { value: number | undefined })[] }[] =>
  config.numbers.map(({ name, selectableMax }) => {
    const field = findFieldByName(play, name)
    return {
      name,
      numbers: Array.from({ length: selectableMax }).map((_, index) => ({
        ...decorate(field, index),
        value: field?.selected[index],
      })),
    }
  })

export const isFieldComplete = (config: Config, play: PlayLike, fieldIndex: number): boolean => {
  const numberConfig = config.numbers[fieldIndex]
  const field = play.fields[fieldIndex]
  if (!numberConfig || !field) return false
  return field.selected.length >= numberConfig.selectableMax
}

export const isPlayComplete = <TPlay extends PlayLike>(
  config: Config,
  play: TPlay,
  fieldComplete: (config: Config, play: TPlay, fieldIndex: number) => boolean,
): boolean => config.numbers.every((_, fieldIndex) => fieldComplete(config, play, fieldIndex))

export const setFieldSelected = (
  play: PlayLike | null | undefined,
  fieldIndex: number,
  selected: number[],
): void => {
  const field = play?.fields[fieldIndex]
  if (!field) return
  field.selected = selected
}
